<template>
  <div style="width: 100%;">
    <div class="panel-group">
      <div
        v-for="(category, index) in quickInsightsCategories"
        :key="index"
        class="panel panel-default quick-insight-category"
      >
        <div
          class="panel-heading quick-insight-category__name clickable"
          @click="toggleAccordion(index)"
        >
          <i
            :class="category.icon"
            class="f-s-16"
          />
          {{ category.name }}
        </div>

        <collapse v-model="showAccordion[index]">
          <div class="panel-body p-0">
            <div
              v-for="(question, questionIndex) in category.questions"
              :key="questionIndex"
              class="quick-insight-category__question clickable"
              @click="goToRoute(question.route)"
            >
              {{ question.question }}
            </div>
          </div>
        </collapse>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

const quickInsightsCategories = [{
  name: 'Basic Insights',
  icon: 'typcn typcn-flow-children',
  questions: [
    {
      question: 'This month by day',
      route: 'dashboard.insights.this-month-by-day'
    },
    {
      question: 'Last month by day',
      route: 'dashboard.insights.last-month-by-day'
    },
  ]
},
{
  name: 'Admin Insights',
  icon: 'typcn typcn-flow-children',
  questions: [
    {
      question: 'Profit and cost analysis',
      route: 'dashboard.insights.admin-profit-and-cost'
    }
  ]
},
{
  name: 'Publisher Performance',
  icon: 'typcn typcn-group',
  questions: [
    {
      question: 'Today\'s profitability',
      route: 'dashboard.insights.pub-today-profitability'
    },
    {
      question: 'Last week\'s profitability',
      route: 'dashboard.insights.pub-last-week-profitability'
    },
    {
      question: 'This month\'s profitability',
      route: 'dashboard.insights.pub-this-month-profitability'
    },
    {
      question: 'Last month\'s profitability',
      route: 'dashboard.insights.pub-last-month-profitability'
    },
  ]
},
{
  name: 'Buyer Performance',
  icon: 'fa fa-dot-circle-o m-r-12',
  questions: [
    {
      question: 'Adjustments this month',
      route: 'dashboard.insights.adjustments-this-month'
    },
    {
      question: 'Adjustments last month',
      route: 'dashboard.insights.adjustments-last-month'
    },
    {
      question: 'Target profitability',
      route: 'dashboard.insights.target-profitability'
    }
  ]
}];

export default Vue.extend({
  name: 'QuickInsights',
  props: {
  },
  data() {
    return {
      showAccordion: [true],
      quickInsightsCategories: Object.freeze(quickInsightsCategories),
    };
  },
  methods: {
    toggleAccordion(index) {
      this.showAccordion = this.showAccordion.map((v, i) => i === index);
      this.$set(this.showAccordion, index, true);
    },

    goToRoute(route) {
      utilities.goToRoute({ routeName: route, paramsObj: {
        source: 'quickInsights'
      }});
    },
  },
});
</script>

<style lang="scss" scoped>
.quick-insight-category {
  margin-bottom: 5px;
  border: none;
  
  &:last-of-type {
    margin-bottom: 0;
  }
}

.quick-insight-category__name {
  font-size: 15px;
  padding: 8px 8px;
  border-bottom: 1px solid #{theme-color-level("dark", -3)};
}

.quick-insight-category__question {
  border-bottom: 1px solid #{theme-color-level("dark", -3)};
  padding: 10px;

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    color: var(--contrast);
  }
}
</style>